import React, { Component } from 'react';
import { UIView} from 'ui-router-react'; 
import { CSSTransitionGroup } from 'react-transition-group'; 
import {UISref,UISrefActive} from 'ui-router-react'; 
import Flexbox from '../components/misc/Flexbox'; 

class KalenderKategorieContainer extends Component {
	componentDidMount(){	
		setTimeout(function(){
			document.getElementById('menu-programm').classList.add('active');
			document.getElementById('submenu-kalender').classList.add('active');
		},400);
	}
	componentWillUnmount(){
		document.getElementById('menu-programm').classList.remove('active');
		document.getElementById('submenu-kalender').classList.remove('active');
	}
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}
	render() {	
			const {kategories,page} = this.props.resolves;
		   return (
				<div>
					<div className="container-fluid lg-side-padding">
						<ul className="categories-menu">
							<li>
								<UISref to="root.programm.kalender">
									<a>Alle</a>
								</UISref>
							</li>
							{
								kategories.map( (data,i)=> {
									if(data.event_count>0){
									return (
										<UISrefActive class="selected" key={i} >
												<UISref to="root.programm.kalender-kategorie.name" params={{item:data.slug}} >
													<li>
														<a href="">{data.name}</a>
													</li>
												</UISref>
											</UISrefActive>	
									)
									}
									else
										return '';
									
								})
							}						
						</ul>
						<Flexbox left={page.title_left} right={page.title_right} /> 	
					</div>
					<UIView render={(Comp, props) =>
					  <CSSTransitionGroup
						transitionName="example"
						transitionEnterTimeout={250}
						transitionLeaveTimeout={250}>
						<Comp {...props} key={props.transition} />
					  </CSSTransitionGroup>
					}/>
				</div>
			)
	   
	}
}
export default KalenderKategorieContainer;


// WEBPACK FOOTER //
// ./src/containers/KalenderKategorieContainer.js